export enum BlockTypeEnum {
  /**
   * @description
   * Zwykły blok
   */
  UNIVERSAL_TYPE = 0,

  // BLOKI NA STRONIE WWW
  /**
   * @description
   * Slider na stronie
   */
  SLIDER_TYPE = 1,

  /**
   * @description
   * Menu (mobilne i normalne)
   */
  MENU_TYPE = 2,

  /**
   * @description
   * Stopka strony
   */
  FOOTER_TYPE = 3,

  /**
   * @description
   * Filtry listy inwentarza
   */
  INVENTORY_FILTERS_TYPE = 4,

  /**
   * @description
   * Filtry listy newsów
   */
  NEWS_FILTERS_TYPE = 5,

  /**
   * @description
   * Przełącznik języków
   */
  LANGUAGE_SWITCH_TYPE = 6,

  /**
   * @description
   * Lista inwentarzy na stronie
   */
  INVENTORIES_LIST_TYPE_WWW = 7,

  /**
   * @description
   * Lista wystaw na stronie
   */
  EXHIBITIONS_LIST_TYPE = 8,

  /**
   * @description
   * Lista newsów na stronie
   */
  NEWS_LIST_TYPE = 9,

  /**
   * @description
   * Lightbox (modal z podglądem zdjęcia)
   */
  LIGHTBOX_TYPE = 10,

  /**
   * @description
   * Komunikat na stronie
   */
  COOKIES_ALERT_TYPE = 11,

  /**
   * @description
   * Formularz kontaktowy na stronie
   */
  CONTACT_FORM_TYPE = 12,

  // BLOKI NA PDF
  /**
   * @description
   * Nagłówek PDF
   */
  DOCUMENT_HEADER_TYPE = 13,

  /**
   * @description
   * Stopka PDF
   */
  DOCUMENT_FOOTER_TYPE = 14,

  /**
   * @description
   * Lista inwentarzy PDF
   */
  INVENTORIES_LIST_TYPE_PDF = 15,

  // BLOKI NA SZABLON EMAIL
  /**
   * @description
   * Nagłówek email
   */
  EMAIL_HEADER_TYPE = 16,

  /**
   * @description
   * Stopka email
   */
  EMAIL_FOOTER_TYPE = 17,

  /**
   * @description
   * Lista inwentarzy email
   */
  INVENTORIES_LIST_TYPE_EMAIL = 18,

  /**
   * @description
   * Przycisk na stronie
   */
  BUTTON_TYPE = 19,

  /**
   * @description
   * Lista artystów na stronie
   */
  ARTISTS_LIST_TYPE_WWW = 20,

  /**
   * @description
   * Paginacja na stronie
   */
  PAGINATION_TYPE = 21,

  /**
   * @description
   * Filtry listy artystów
   */
  ARTISTS_FILTERS_TYPE = 22,

  /**
   * @description
   * Okno dialogowe
   */
  POPUP_TYPE = 23,

  /**
   * @description
   * Rejestracja konta
   */
  REGISTER_TYPE = 24,

  /**
   * @description
   * Logowanie
   */
  LOGIN_TYPE = 25,

  /**
   * @description
   * Dropdown "Moje konto"
   */
  MY_ACCOUNT_DROPDOWN_TYPE = 26,

  /**
   * @description
   * Dropdown zmiany waluty
   */
  CURRENCY_CHANGE_DROPDOWN_TYPE = 27,

  /**
   * @description
   * Formularz
   */
  FORM_TYPE = 28,

  /**
   * @description
   * Koszty transportu
   */
  TRANSPORT_COSTS_TYPE = 29,

  /**
   * @description
   * Ikonka koszyka
   */
  BASKET_ICON_TYPE = 30,


  /**
   * @description
   * Filtry wystaw
   */
  EXHIBITIONS_FILTERS_TYPE = 31,

  /**
   * @description
   * Kontrolka wyszukiwania dla filtrów
   */
  FILTER_SEARCH_INPUT_TYPE = 32,
  /**
   * @description
   * Kontrolka wyboru grupowego dla filtrów
   */
  FILTER_GROUP_SELECTOR_TYPE = 33,

  /**
   * @description
   *  Kontrolka wyboru pojedyńczego dla filtrów
   */
  FILTER_SINGLE_SELECTOR_TYPE = 34,

  /**
   * @description
   * Formularz kontaktowy na stronie pracy
   */
  CONTACT_FORM_FOR_ARTWORK_TYPE = 35,

  /**
   * @description
   * Lightbox CMS
   */
  LIGHTBOX_CMS_TYPE = 36,

  /**
   * @description
   * Brak wynikow wyszukiwania
   */
  NO_SEARCH_RESULTS_TYPE = 37,
  GLOBAL_SEARCH_INPUT_TYPE = 38,
  GLOBAL_SEARCH_RESULTS_LIST_TYPE = 39,


  SORTING_LIST_TYPE = 40,

  /**
   * @description
   * Formularz resetowanie hasła
   */
  PASSWORD_RESET_TYPE = 50,

  /**
   * @description
   * Wyszukiwanie suwak po cennie
   */
  SLIDER_PRICE_RANGE_TYPE = 51,

  /**
   * @description
   * Wyszukiwanie suwak rok powstania
   */
  SLIDER_YEAR_OF_CREATION = 52,


  /**
   * @description
   * TypY bloków sortowania
   */
  BLOCK_TYPE_SORTING = 53,
  /**
   * @description
   * Formularz zgłaszania prac
   */
  ARTWORK_REQUEST_FORM = 54,
  /**
   * @description
   * Advanced filters
   */
  INVENTORY_ADVANCED_FILTERS_TYPE = 55,
  ADVANCED_FILTER_GROUP_SELECTOR_TYPE = 56,
  ACTIVE_FILTERS_PREVIEW_TYPE = 57,
  RANGE_YEAR_OF_CREATION = 58,
  RANGE_PRICE_OF_CREATION = 59,

  /**
   * @description
   * Wizualizacja pracy na ścianie (view on the wall)
   */
  VIEW_ON_WALL_PREVIEW_TYPE = 60,

  /**
   * @description
   * Konfigurator ceny na karcie pracy — wybór edycji i parametrów dodatkowych,
   * kwota z serwera i przycisk zakupu. Obsługuje też pracę bez edycji.
   *
   * Numer 61, nie 60: obie gałęzie zajęły niezależnie 60, a dev jest wspólnym pniem
   * i jego typ jest już zapisany na blokach w bazach. Konfigurator nie był nigdzie
   * zmergowany, więc przenumerowanie dotyczy wyłącznie danych testowych tej gałęzi.
   */
  PRICE_CONFIGURATOR_TYPE = 61,
}
